import { Camera, Clapperboard, Music2, Pin, ThumbsUp, type LucideIcon } from 'lucide-react';

export type SocialNetworkId = 'pinterest' | 'instagram' | 'facebook' | 'tiktok' | 'youtube';

export interface SocialNetwork {
  id: SocialNetworkId;
  icon: LucideIcon;
  /** Classes of the network's tile, in its brand colour. */
  tile: string;
}

/**
 * Every network the Social hub shows, in its order. Labels live under `social:<id>.name`; Pinterest
 * is the only one with its own section so far, the rest are announced as coming soon.
 */
export const SOCIAL_NETWORKS: readonly SocialNetwork[] = [
  { id: 'pinterest', icon: Pin, tile: 'bg-[#E60023] text-white' },
  {
    id: 'instagram',
    icon: Camera,
    tile: 'bg-linear-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white',
  },
  { id: 'facebook', icon: ThumbsUp, tile: 'bg-[#1877F2] text-white' },
  { id: 'tiktok', icon: Music2, tile: 'bg-foreground text-background' },
  { id: 'youtube', icon: Clapperboard, tile: 'bg-[#FF0000] text-white' },
];

export function socialNetwork(id: SocialNetworkId): SocialNetwork {
  const network = SOCIAL_NETWORKS.find((row) => row.id === id);
  if (!network) throw new Error(`Unknown social network ${id}`);
  return network;
}
